import { render } from "./InternalProductRecommendationsPage.vue?vue&type=template&id=55363ecb"
import script from "./InternalProductRecommendationsPage.vue?vue&type=script&lang=js"
export * from "./InternalProductRecommendationsPage.vue?vue&type=script&lang=js"

import "./InternalProductRecommendationsPage.vue?vue&type=style&index=0&id=55363ecb&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__